import React from "react";
import { useDispatch } from "react-redux";
import { toggleCart } from "../../../store/actions";
import { useTranslation } from "react-i18next";

const Header = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["checkout"]);

  /**
   * Close cart side bar
   */
  const closeCartSideBar = () => {
    dispatch(toggleCart(false));
  };

  return (
    <div className="cart-header">
      <h2 className="cart-title">{t("My cart")}</h2>
      <div className="cart-close">
        <img
          onClick={() => closeCartSideBar()}
          src={`${process.env.IMAGES_BASE_URL}/static/vendors/images/icons/cancel_major.svg`}
          alt="close"
        />
      </div>
    </div>
  );
};

export default Header;
